import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-arrow-up",
  "use": "icon-arrow-up-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-arrow-up\"><defs><style type=\"text/css\">@font-face { font-family: element-icons; src: url(\"chrome-extension://moombeodfomdpjnpocobemoiaemednkg/fonts/element-icons.woff\") format(\"woff\"), url(\"chrome-extension://moombeodfomdpjnpocobemoiaemednkg/fonts/element-icons.ttf \") format(\"truetype\"); }\n</style></defs><path d=\"M500.8 461.909333L267.306667 695.296l-45.226667-45.269333 278.741333-278.613334L779.306667 650.026667l-45.248 45.226666z\" p-id=\"4513\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/m-common/svg/md-icon/arrow-up.svg
// module id = JKu4
// module chunks = 317